<template>
    <DeviceData
        ref="deviceData"
        :uiMode="viewItem.uiMode"
        :deviceLocation="viewItem.deviceLocation"
        :period="viewItem.searchPeriod"
        :graphData="viewItem.graphData"
    />
</template>

<script setup>
import client from "../api/client.js";
import {
    ref,
    reactive,
    onBeforeMount,
    onMounted,
    onUpdated,
    onUnmounted
} from "vue";
import {
    faLog,
    getFirePortRole,
    getFirePortDefinition
} from "../common/faCommon.js";
import DeviceData from "../components/DeviceData.vue";

const FN = "[DeviceDataView] ";

const props = defineProps({
    clientOs: {
        type: String,
        required: false,
    },
});

const deviceData = ref();

const viewItem = reactive({
    numSubBoard: 0,
    uiMode: "",
    deviceMainIdx: "",
    deviceLocation: {
        buildingName: "",
        detailAddress: "",
        installedLocation: "",
        roadAddress: "",
        sido: "",
        sigungu: "",
        zipCode: "",
    },
    searchPeriod: {
        type: 0,
        fromDt: "",
        toDt: "",
    },
    graphDataRaw: [],
    graphData: [],
});

const onUpdateView = (
    uiMode,
    strDeviceDataSearchPeriodDto,
    strDeviceMainInfoDto
) => {
    faLog(0, FN + "[onUpdateView] strDeviceDataSearchPeriodDto : " + strDeviceDataSearchPeriodDto);
    viewItem.uiMode = uiMode;

    const deviceMainInfoDto = JSON.parse(strDeviceMainInfoDto);
    viewItem.deviceMainIdx = deviceMainInfoDto.idx;

    const deviceDataSearchPeriodDto = JSON.parse(strDeviceDataSearchPeriodDto);
    viewItem.searchPeriod = {
        type: deviceDataSearchPeriodDto.type,
        fromDt: (deviceDataSearchPeriodDto.from).replace("T", " "),
        toDt: (deviceDataSearchPeriodDto.to).replace("T", " "),
    };
    faLog(2, FN + "[onUpdateView] searchPeriod", viewItem.searchPeriod);

    const deviceLocationDto = deviceMainInfoDto.deviceLocationDto;
    viewItem.deviceLocation = {
        buildingName: deviceLocationDto.buildingName,
        detailAddress: deviceLocationDto.detailAddress,
        installedLocation: deviceLocationDto.installedLocation,
        roadAddress: deviceLocationDto.roadAddress,
        sido: deviceLocationDto.sido,
        sigungu: deviceLocationDto.sigungu,
        zipCode: deviceLocationDto.zipCode,
    };

    viewItem.graphData.splice(0, viewItem.graphData.length);
    const _deviceSubDtoList = deviceMainInfoDto.deviceSubDtoList;
    viewItem.numSubBoard = _deviceSubDtoList.length;
    for (let m = 0; m < _deviceSubDtoList.length; m++) {
        const _firePortList = _deviceSubDtoList[m].firePortDtoList;
        for (let n = 0; n < _firePortList.length; n++) {
            const firePort = {
                name: _firePortList[n].portName,
                number: "L" + String(m * 8 + n + 1).padStart(2, "0"),
                role: {
                    name: getFirePortRole(_firePortList[n].portRole),
                    value: _firePortList[n].portRole
                },
                dataList: {
                    voltageList: [],
                    rangeList: [],
                },
            };
            const _firePortConfigList = _firePortList[n].firePortConfigDtoList;
            for (let p = 0; p < _firePortConfigList.length; p++) {
                const _firePortConfig = _firePortConfigList[p];
                if (_firePortConfig.portConfigRole < 1) {
                    continue;
                }
                firePort.dataList.rangeList.push({
                    name: getFirePortDefinition(_firePortConfig.portConfigRole),
                    value: parseFloat(((_firePortConfig.maxVoltage + 1) / 10) - 1).toFixed(0),
                });
            }
            viewItem.graphData.push(firePort);
        }
    }
};

const updateGraphData = () => {
    faLog(0, FN + "[updateGraphData]");
    // faLog(2, FN + "[updateGraphData] viewItem.graphDataRaw", viewItem.graphDataRaw);
    for (let m = 0; m < viewItem.graphData.length; m++) {
        viewItem.graphData[m].dataList.voltageList.splice(0, viewItem.graphData[m].dataList.voltageList.length);
    }

    for (let m = 0; m < viewItem.graphDataRaw.length; m++) {
        const portDataRaw = (viewItem.graphDataRaw[m].portData).split(",");
        const datetime = (m === 0 ?
            viewItem.graphDataRaw[m].regDatetime :
            viewItem.graphDataRaw[m].updDatetime).replace("T", " ");

        for (let n = 0; n < viewItem.numSubBoard; n++) {
            for (let p = 1; p < 17; p+=2) {
                const voltage = portDataRaw[(n * 17) + p];
                const idx = n * 8 + ((p - 1) / 2);
                viewItem.graphData[idx].dataList.voltageList.push({
                    dt: refineDatetimeString(datetime),
                    value: parseFloat(voltage / 10).toFixed(1),
                });
            }
        }
    }
    deviceData.value.onUpdateGraph();
};

const onUpdateData = (accessToken) => {
    client.defaults.headers.common.Authorization = "Bearer " + accessToken;
    const searchPeriod = {
        type: viewItem.searchPeriod.type,
        fromDt: (viewItem.searchPeriod.fromDt).replace(" ", "T"),
        toDt: (viewItem.searchPeriod.toDt).replace(" ", "T"),
    };
    faLog(2, FN + "[onUpdateData] searchPeriod", searchPeriod);
    client.post("/device_data/" + viewItem.deviceMainIdx, searchPeriod)
    .then((res) => {
        viewItem.graphDataRaw = res.data;
        updateGraphData();
    })
    .catch((error) => {
        faLog(2, FN + "[onUpdateData] error", error);
    });
};

const refineDatetimeString = (datetime) => {
    if (datetime.length !== "2024-12-31 23:59:59.999".length) {
        return datetime;
    }
    return datetime.substr(0, datetime.length - 4);
};

onBeforeMount(() => {
    faLog(0, FN + "[onBeforeMount]");
    window.onUpdateView = onUpdateView;
    window.onUpdateData = onUpdateData;
});

onMounted(() => {
    faLog(0, FN + "[onMounted]");
});

onUpdated(() => {
    faLog(0, FN + "[onUpdated]");
});

onUnmounted(() => {
    faLog(0, FN + "[onUnmounted]");
});

</script>



